import { leadStatusOptions } from 'utils/helpers/constVariables';

export const getLeadStatusRu = (status: string | null) => {
  const ruStatus = leadStatusOptions.find(statusEl => statusEl.id === status);
  if (!ruStatus) return '';
  return ruStatus.name;
};
